export const _asfMimeTypes = ["video/x-ms-asf"];
